import React, { useState, useEffect } from "react";
import {  useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import LogoDash from "../../assets/auth_logo.png";
import "./styles/style.css";

import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { usePostVerifyUserProfileMutation } from "../../rtk-query/slices/auth/authSlice";

const VerifyProfileMain = (props) => {
  const navigate = useNavigate();
  const [verified, setVerified] = useState(false);
  const { token } = useParams();

  const [postVerifyUserProfile, { isLoading }] =
    usePostVerifyUserProfileMutation();

  useEffect(() => {
    const handleVerify = async () => {
      try {
        const response = await postVerifyUserProfile(token.toString()   );
        if (response.data.status) {
          setVerified(true);
          navigate("/");
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      } catch (error) {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      } finally {
        
      }
    };

    handleVerify();
  }, []);

  // Now you have the token and can use it as needed
  return (
    <div className="verify-email-main" data-theme={props.isDark}>
      <Card style={{ width: "36rem" }}>
        <Card.Img variant="top" src={LogoDash} />
        <Card.Body>
          <Card.Title>Verifying your email address</Card.Title>
          <Card.Text>
            You are almost ready to get started. Please wait while we verify
            your email
          </Card.Text>
          {!verified ? (
            <div className="w-100 align-items-center justify-content-center text-center">
              <Spinner animation="border" className="global-spinner" />
            </div>
          ) : (
            ""
          )}
        </Card.Body>
      </Card>
      {/* Other components or logic related to the token */}
    </div>
  );
};

export default VerifyProfileMain;
